import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface NotesFilterFieldsProps {
  notesId: string;
  notesEmptyId: string;
  notesValue?: string;
  notesIsEmpty?: boolean;
  onNotesChange: (notes: string | undefined) => void;
  onNotesIsEmptyChange: (isEmpty: boolean) => void;
  notesPlaceholderKey?: string;
  notesLabelKey?: string;
  /** 視覚ラベルを隠すとき（placeholder 任せ） */
  labelClassName?: string;
}

/** 備考テキスト検索 + 「空欄のみ」チェック（サンプル管理・レポート共通） */
export default function NotesFilterFields({
  notesId,
  notesEmptyId,
  notesValue = '',
  notesIsEmpty = false,
  onNotesChange,
  onNotesIsEmptyChange,
  notesPlaceholderKey = 'sample_filter.filter_notes_placeholder',
  notesLabelKey = 'sample_filter.filter_notes',
  labelClassName,
}: NotesFilterFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className="sample-notes-filter-fields">
      <Form.Label htmlFor={notesId} className={labelClassName}>
        {t(notesLabelKey)}
      </Form.Label>
      <div className="d-flex align-items-center gap-2 flex-nowrap">
        <Form.Control
          id={notesId}
          name="notes"
          type="text"
          className="flex-grow-1 min-w-0"
          placeholder={t(notesPlaceholderKey)}
          aria-label={t(notesLabelKey)}
          value={notesIsEmpty ? '' : notesValue}
          disabled={notesIsEmpty}
          onChange={(e) => {
            const next = e.target.value;
            onNotesChange(next || undefined);
            if (next && notesIsEmpty) {
              onNotesIsEmptyChange(false);
            }
          }}
          autoComplete="off"
        />
        <Form.Check
          inline
          id={notesEmptyId}
          className="mb-0 flex-shrink-0 text-nowrap sample-notes-empty-check"
        >
          <Form.Check.Input
            type="checkbox"
            checked={notesIsEmpty}
            aria-label={t('sample_filter.filter_notes_empty_only')}
            title={t('sample_filter.filter_notes_empty_only_title')}
            onChange={(e) => {
              onNotesIsEmptyChange(e.target.checked);
            }}
          />
          <Form.Check.Label title={t('sample_filter.filter_notes_empty_only_title')}>
            {t('sample_filter.filter_notes_empty_only')}
          </Form.Check.Label>
        </Form.Check>
      </div>
    </div>
  );
}
